import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectSheet from 'react-jss';

const styles = theme => ({

  flex: {
    display: 'flex',
  },
  center: {
    margin: '0 auto',
  },
  stretch: {
    flex: 1,
  },
  'direction-column': {
    flexDirection: 'column',
  },
  'direction-column-reverse': {
    flexDirection: 'column-reverse',
  },
  'direction-row-reverse': {
    flexDirection: 'row-reverse',
  },
  'align-items-center': {
    alignItems: 'center',
  },
  'align-items-flex-start': {
    alignItems: 'flex-start',
  },
  'align-items-flex-end': {
    alignItems: 'flex-end',
  },
  'align-items-baseline': {
    alignItems: 'baseline',
  },
  'align-content-center': {
    alignContent: 'center',
  },
  'align-content-flex-start': {
    alignContent: 'flex-start',
  },
  'align-content-flex-end': {
    alignContent: 'flex-end',
  },
  'align-content-space-between': {
    alignContent: 'space-between',
  },
  'align-content-space-around': {
    alignContent: 'space-around',
  },
  'justify-center': {
    justifyContent: 'center',
  },
  'justify-flex-end': {
    justifyContent: 'flex-end',
  },
  'justify-space-between': {
    justifyContent: 'space-between',
  },
  'justify-space-around': {
    justifyContent: 'space-around',
  },
  // 'max-width-xs': {
  //   maxWidth: '100%',
  // },
  // 'max-width-sm': {
  //   maxWidth: 400,
  // },
  // 'max-width-md': {
  //   maxWidth: 960,
  // },
  // 'max-width-lg': {
  //   maxWidth: 1280,
  // },
  // 'max-width-xl': {
  //   maxWidth: 1920,
  // },
  'padding-0': {
    padding: 0,
  },
  'padding-4': {
    padding: 4,
  },
  'padding-8': {
    padding: 8,
  },
  'padding-16': {
    padding: 16,
  },
  'padding-24': {
    padding: 24,
  },
  'padding-40': {
    padding: 40,
  },
});

const paddingArr = [-1, 0, 4, 8, 16, 24, 40];

class Container extends React.Component {
  render() {
    const {
      children,
      classes,
      className: classNameProp,
      component: Component,

      flex,
      stretch,
      direction,
      alignItems,
      alignContent,
      justify,
      padding,
      maxWidth,
      center,
      style,
      id,
      onClick,
    } = this.props;
    const className = classNames(
      {
        [classes.flex]: flex,
        [classes.stretch]: stretch,
        [classes[`direction-${String(direction)}`]]: direction !== Container.defaultProps.direction,
        [classes[`align-items-${String(alignItems)}`]]: alignItems !== Container.defaultProps.alignItems,
        [classes[`align-content-${String(alignContent)}`]]: alignContent !== Container.defaultProps.alignContent,
        [classes[`justify-${String(justify)}`]]: justify !== Container.defaultProps.justify,
        [classes[`padding-${String(padding)}`]]: paddingArr.includes(padding),
        [classes[`max-width-${String(maxWidth)}`]]: maxWidth !== Container.defaultProps.maxWidth,
        [classes.center]: center,
      },
      classNameProp,
    );
    return (
      <Component
        ref={(node) => { this.box = node; }}
        className={className}
        style={style}
        id={id}
        onClick={onClick}
      >
        {children}
      </Component>
    );
  }
}

Container.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  scroll: PropTypes.bool,
  disableScrollX: PropTypes.bool,
  container: PropTypes.bool,
  center: PropTypes.bool,
  style: PropTypes.object,

  flex: PropTypes.bool,
  stretch: PropTypes.bool,
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
  alignContent: PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
  justify: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),
  padding: PropTypes.oneOf(paddingArr),
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  rootRef: PropTypes.func,
  id: PropTypes.string,
  onClick: PropTypes.func,
};

Container.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  component: 'div',
  direction: 'row',
  justify: 'flex-start',
  padding: -1,
  maxWidth: 'xs',
  scroll: false,
  container: false,
  center: false,
  style: {},
  handleScrollY: () => { },
  rootRef: () => { },
  disableScrollX: true,
};

export default injectSheet(styles)(Container);
